import {
  CUSTOMER_ID_KEY,
  HMS_KEY,
  ID_KEY,
  LEVEL_KEY,
  RECORD_CREATED_KEY,
  REFUND_DATETIME_KEY,
  STORE_NAME_KEY,
  TIMESTAMP_KEY,
  TOTAL_COST_KEY,
  UUID_KEY,
} from '@/features/purchaseWithoutScanPage/consts/keys';
import { createDateRangeFilter } from '@/filters/DateRange';
import { createDateTimeRangeFilter } from '@/filters/DateTimeRange';
import { createMoneyRangeFilter } from '@/filters/MoneyRange';
import { createEqualsFilter, createTextFilter } from '@/filters/SearchInput';
import { createTimeRangeFilter } from '@/filters/TimeRange';
import { createUserStatusFilter } from '@/filters/UserStatus';

export const filterTypes = [
  createEqualsFilter({
    key: ID_KEY,
    label: 'ID Покупки',
  }),
  createEqualsFilter({
    key: CUSTOMER_ID_KEY,
    label: 'ID Покупателя',
  }),
  createTextFilter({
    key: STORE_NAME_KEY,
    label: 'Магазин',
  }),
  createTextFilter({
    key: UUID_KEY,
    label: 'UUID',
  }),
  createDateRangeFilter({
    key: TIMESTAMP_KEY,
    label: 'Дата покупки',
  }),
  createTimeRangeFilter({
    key: HMS_KEY,
    label: 'Время покупки',
  }),
  createMoneyRangeFilter({
    key: TOTAL_COST_KEY,
    label: 'Общая сумма покупки',
  }),
  createDateTimeRangeFilter({
    key: RECORD_CREATED_KEY,
    label: 'Дата и время добавления покупки',
  }),
  createDateTimeRangeFilter({
    key: REFUND_DATETIME_KEY,
    label: 'Дата и время возврата',
  }),
  createUserStatusFilter({
    key: LEVEL_KEY,
    label: 'Статус',
    quicklyAccessible: true,
  }),
];

export const filterPrefixes = [
  {
    field: ID_KEY,
    prefix: 'eq',
  },
  {
    field: LEVEL_KEY,
    prefix: 'in',
  },
  {
    field: CUSTOMER_ID_KEY,
    prefix: 'eq',
  },
  {
    field: STORE_NAME_KEY,
    prefix: 'ilike',
  },
  {
    field: UUID_KEY,
    prefix: 'ilike',
  },
  {
    field: TIMESTAMP_KEY,
    prefix: 'eq',
  },
  {
    field: HMS_KEY,
    prefix: 'eq',
  },
  {
    field: TOTAL_COST_KEY,
    prefix: 'eq',
  },
  {
    field: RECORD_CREATED_KEY,
    prefix: 'eq',
  },
  {
    field: REFUND_DATETIME_KEY,
    prefix: 'eq',
  },
];

export const multipleFilterList = [
  TIMESTAMP_KEY,
  HMS_KEY,
  TOTAL_COST_KEY,
  REFUND_DATETIME_KEY,
  RECORD_CREATED_KEY,
];
